import React from 'react'
import injectSheet from 'react-jss'

const InfoContainer = (props) => {
  const {
    classes,
    children,
    warning,
  } = props

  return (
    <div className={`${classes.container}`}>
      <div className={`${classes.infoContainer} ${warning && 'warning'}`}>
        {children}
      </div>
    </div>
  )
}

const styles = theme => ({
  container: {
    padding: `${theme.sizes.gutter / 2}px`,
  },
  infoContainer: {
    width: '100%',
    backgroundColor: theme.colors.main_2,
    padding: `${theme.sizes.gutter}px`,
    borderWidth: '5px',
    borderColor: theme.colors.main_5,
    borderStyle: 'solid',
    borderRadius: '10px',
    fontSize: '60%',
    [theme.media.medium]: {
      fontSize: '100%',
    },
    '& > h2': {
      color: theme.colors.main_5,
    },
    '& > h4': {
      color: theme.colors.main_3,
    },
    '& > p': {
      color: theme.colors.secondary_3b,
      fontSize: '1.2em',
      lineHeight: '1.8',
    },
    '&.warning': {
      borderColor: theme.colors.main_1,
      '& > h2': {
        color: theme.colors.main_1,
      },
    },
  },
})

export default injectSheet(styles)(InfoContainer)



// WEBPACK FOOTER //
// ./src/modules/core/components/infoContainer.jsx